function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".boat_outline_stroke{fill:none;stroke:currentColor;stroke-width:2;stroke-miterlimit:10;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "boat_outline"
}, /*#__PURE__*/React.createElement("path", {
  className: "boat_outline_fill",
  d: "M70,27c-3.1,3.1-5,7.3-5,12H6V27h32V15h20c-3.1,3.1-5,7.3-5,12C53,27,70,27,70,27z"
}), /*#__PURE__*/React.createElement("line", {
  className: "boat_outline_stroke",
  x1: 65,
  y1: 39,
  x2: 72,
  y2: 39
}), /*#__PURE__*/React.createElement("line", {
  className: "boat_outline_stroke",
  x1: 0,
  y1: 39,
  x2: 6,
  y2: 39
}), /*#__PURE__*/React.createElement("path", {
  className: "boat_outline_stroke",
  d: "M53,27h17c-3.1,3.1-5,7.3-5,12H6V27l32,0V15h20C54.9,18.1,53,22.3,53,27z"
}), /*#__PURE__*/React.createElement("line", {
  className: "boat_outline_stroke",
  x1: 38,
  y1: 15,
  x2: 38,
  y2: 5
}), /*#__PURE__*/React.createElement("line", {
  className: "boat_outline_stroke",
  x1: 38,
  y1: 21,
  x2: 21,
  y2: 4.1
}), /*#__PURE__*/React.createElement("line", {
  className: "boat_outline_stroke",
  x1: 38,
  y1: 21,
  x2: 26,
  y2: 0.2
}));

var SvgBoatOutline = function SvgBoatOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "boatOutlineIcon",
    viewBox: "-2 -2 76 43.53",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoatOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/boat_outline.a1db2b4a.svg";
export { ForwardRef as ReactComponent };